import { CustomErrorType } from "../interfaces/CustomErrorType";

export default {
    code: 'ERR_REWARD_POINT_NOT_MATCH',
    statusCode: 400,
    message: {
        en: 'Required reward point has been updated, please refresh the page',
    },
} as CustomErrorType;